import { runningInRNWebView } from '@eika-infrastruktur/mobilbank-lib';
import { useQuery, QueryOptions, QueryResult } from '@eika-infrastruktur/react-query';

import type { StepUpStatusResponse } from '../generated-types';
import { getStepUpStatus } from '../services/paymentService';

export const useStepUpStatus = (
    options: Partial<QueryOptions<StepUpStatusResponse>> = {},
): QueryResult<StepUpStatusResponse> => {
    const deviceId = window.ReactNativeProps?.deviceId;
    return useQuery({
        ...options,
        queryKey: ['stepUpStatus'],
        queryFn: () => getStepUpStatus(deviceId as string),
        enabled: runningInRNWebView && !!deviceId,
    });
};
